const ACCOUNT_ICON_VIEW_BOX = '0 -960 960 960';

const ACCOUNT_ICONS = Object.freeze({
    accountCircle: Object.freeze({
        symbol: 'account_circle',
        path: 'M240.92-268.31q51-37.84 111.12-59.77Q412.15-350 480-350t127.96 21.92'
            + 'q60.12 21.93 111.12 59.77 37.3-41 59.11-94.92Q800-417.15 800-480q0-133-93.5-226.5T480-800'
            + 'q-133 0-226.5 93.5T160-480q0 62.85 21.81 116.77 21.81 53.92 59.11 94.92Zm146.7-219.31'
            + 'Q350-525.23 350-580q0-54.77 37.62-92.38Q425.23-710 480-710q54.77 0 92.38 37.62'
            + 'Q610-634.77 610-580q0 54.77-37.62 92.38Q534.77-450 480-450q-54.77 0-92.38-37.62ZM480-100'
            + 'q-79.15 0-148.5-29.77t-120.65-81.08q-51.31-51.3-81.08-120.65Q100-400.85 100-480t29.77-148.5'
            + 'q29.77-69.35 81.08-120.65 51.3-51.31 120.65-81.08Q400.85-860 480-860t148.5 29.77'
            + 'q69.35 29.77 120.65 81.08 51.31 51.3 81.08 120.65Q860-559.15 860-480t-29.77 148.5'
            + 'q-29.77 69.35-81.08 120.65-51.3 51.31-120.65 81.08Q559.15-100 480-100Zm104.42-77.42'
            + 'q50.27-17.43 89.27-48.73-39-30.16-88.11-47Q536.46-290 480-290t-105.77 16.65'
            + 'q-49.31 16.66-87.92 47.2 39 31.3 89.27 48.73Q425.85-160 480-160t104.42-17.42Zm-54.5-352.66'
            + 'Q550-550.15 550-580t-20.08-49.92Q509.85-650 480-650t-49.92 20.08Q410-609.85 410-580t20.08 49.92'
            + 'Q450.15-510 480-510t49.92-20.08ZM480-580Zm0 355Z',
    }),
    expandMore: Object.freeze({
        symbol: 'expand_more',
        path: 'M466.54-375.85q-6.23-2.3-11.85-7.92L274.92-563.54'
            + 'q-8.3-8.31-8.5-20.88-.19-12.58 8.5-21.27 8.7-8.69 21.08-8.69 12.38 0 21.08 8.69L480-442.77'
            + 'l162.92-162.92q8.31-8.31 20.89-8.5 12.57-.19 21.27 8.5 8.69 8.69 8.69 21.07 0 12.39-8.69 21.08'
            + 'L505.31-383.77q-5.62 5.62-11.85 7.92-6.23 2.31-13.46 2.31t-13.46-2.31Z',
    }),
    chevronRight: Object.freeze({
        symbol: 'chevron_right',
        path: 'M517.85-480 354.92-642.92q-8.3-8.31-8.5-20.89-.19-12.57 8.5-21.27 8.7-8.69 21.08-8.69'
            + ' 12.38 0 21.08 8.69l179.77 179.77q5.61 5.62 7.92 11.85 2.31 6.23 2.31 13.46t-2.31 13.46'
            + 'q-2.31 6.23-7.92 11.85L397.08-274.92q-8.31 8.3-20.89 8.5-12.57.19-21.27-8.5-8.69-8.7-8.69-21.08'
            + ' 0-12.38 8.69-21.08L517.85-480Z',
    }),
    confirmationNumber: Object.freeze({
        symbol: 'confirmation_number',
        path: 'M172.31-180q-29.83 0-51.07-21.24Q100-222.48 100-252.31v-109.61'
            + 'q0-9.85 5.66-17.46 5.65-7.62 15.11-10.39 26.31-12.23 42.77-36.32Q180-450.19 180-480.02'
            + 't-16.46-53.9q-16.46-24.08-42.77-36.31-9.46-2.77-15.11-10.39-5.66-7.61-5.66-17.46v-109.61'
            + 'q0-29.83 21.24-51.07Q142.48-780 172.31-780h615.38q29.83 0 51.07 21.24Q860-737.52 860-707.69'
            + 'v109.61q0 9.85-5.66 17.46-5.65 7.62-15.11 10.39-26.31 12.23-42.77 36.32Q780-509.81 780-479.98'
            + 't16.46 53.9q16.46 24.08 42.77 36.31 9.46 2.77 15.11 10.39 5.66 7.61 5.66 17.46v109.61'
            + 'q0 29.83-21.24 51.07Q817.52-180 787.69-180H172.31Zm0-60h615.38q5.39 0 8.85-3.46t3.46-8.85V-342'
            + 'q-37-22-58.5-58.5T720-480q0-43 21.5-79.5T800-618v-89.69q0-5.39-3.46-8.85t-8.85-3.46H172.31'
            + 'q-5.39 0-8.85 3.46t-3.46 8.85V-618q37 22 58.5 58.5T240-480q0 43-21.5 79.5T160-342v89.69'
            + 'q0 5.39 3.46 8.85t8.85 3.46Zm307.7-53.85q12.76 0 21.37-8.63 8.62-8.62 8.62-21.38t-8.63-21.37'
            + 'q-8.63-8.62-21.38-8.62-12.76 0-21.37 8.63-8.62 8.63-8.62 21.39 0 12.75 8.63 21.37 8.63 8.61'
            + ' 21.38 8.61Zm0-156.15'
            + 'q12.76 0 21.37-8.63 8.62-8.63 8.62-21.38 0-12.76-8.63-21.37-8.63-8.62-21.38-8.62-12.76 0-21.37'
            + ' 8.63-8.62 8.63-8.62 21.38 0 12.76 8.63 21.37 8.63 8.62 21.38 8.62Zm0-156.15'
            + 'q12.76 0 21.37-8.63 8.62-8.63 8.62-21.39 0-12.75-8.63-21.37-8.63-8.61-21.38-8.61-12.76 0-21.37'
            + ' 8.63-8.62 8.62-8.62 21.38t8.63 21.37q8.63 8.62 21.38 8.62ZM480-480Z',
    }),
    addCircle: Object.freeze({
        symbol: 'add_circle',
        path: 'M450-450v130q0 12.75 8.63 21.37 8.63 8.63 21.38 8.63 12.76 0 21.37-8.63Q510-307.25 510-320v-130'
            + 'h130q12.75 0 21.37-8.63 8.63-8.63 8.63-21.38 0-12.76-8.63-21.37Q652.75-510 640-510H510v-130'
            + 'q0-12.75-8.63-21.37-8.63-8.63-21.38-8.63-12.76 0-21.37 8.63Q450-652.75 450-640v130H320'
            + 'q-12.75 0-21.37 8.63-8.63 8.63-8.63 21.38 0 12.76 8.63 21.37Q307.25-450 320-450h130Zm30.07 350'
            + 'q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93'
            + 'q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860'
            + 'q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07'
            + 'q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Zm-.07-60'
            + 'q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z',
    }),
    settings: Object.freeze({
        symbol: 'settings',
        path: 'M435.69-100q-20.46 0-35.34-13.58-14.89-13.57-18.12-33.42l-9.77-74.85'
            + 'q-16.07-5.38-32.96-15.07-16.88-9.7-30.19-20.77L240-228.23'
            + 'q-18.85 8.31-37.88 1.61-19.04-6.69-29.58-24.3l-45.08-78.16'
            + 'q-10.54-17.61-6.07-37.27 4.46-19.65 20.46-32.42l59.92-45'
            + 'q-1.38-8.92-1.96-17.92-.58-9-.58-17.93 0-8.53.58-17.34t1.96-19.27l-59.92-45'
            + 'q-16-12.77-20.27-32.62-4.27-19.84 6.27-37.46l44.69-77'
            + 'q10.54-17.23 29.58-24.11 19.03-6.89 37.88 1.42l68.92 29.08q14.47-11.46 30.89-20.96t32.27-15.27'
            + 'L382.23-813q3.23-19.85 18.12-33.42Q415.23-860 435.69-860h88.62'
            + 'q20.46 0 35.34 13.58 14.89 13.57 18.12 33.42l9.77 75.23'
            + 'q18 6.54 32.57 15.27 14.58 8.73 29.43 20.58L720.39-731'
            + 'q18.84-8.31 37.88-1.42 19.04 6.88 29.57 24.11l44.7 77.39'
            + 'q10.54 17.61 6.07 37.27-4.46 19.65-20.46 32.42l-61.46 46.15'
            + 'q2.15 9.69 2.35 18.12.19 8.42.19 16.96 0 8.15-.39 16.58-.38 8.42-2.76 19.27l60.3 45.38'
            + 'q16 12.77 20.66 32.42 4.65 19.66-5.89 37.27l-45.31 77.77'
            + 'q-10.53 17.62-29.76 24.31-19.23 6.69-38.08-1.62l-68.46-29.46'
            + 'q-14.85 11.85-30.31 20.96-15.46 9.12-31.69 14.89L577.77-147q-3.23 19.85-18.12 33.42'
            + 'Q544.77-100 524.31-100h-88.62Zm4.31-60h78.62L533-267.15'
            + 'q30.62-8 55.96-22.73 25.35-14.74 48.89-37.89L737.23-286l39.39-68-86.77-65.38'
            + 'q5-15.54 6.8-30.47 1.81-14.92 1.81-30.15 0-15.62-1.81-30.15-1.8-14.54-6.8-29.7'
            + 'L777.38-606 738-674l-100.54 42.38q-20.08-21.46-48.11-37.92-28.04-16.46-56.73-23.31L520-800'
            + 'h-79.38l-13.24 106.77q-30.61 7.23-56.53 22.15-25.93 14.93-49.47 38.46L222-674l-39.38 68'
            + 'L269-541.62q-5 14.24-7 29.62t-2 32.38q0 15.62 2 30.62 2 15 6.62 29.62l-86 65.38L222-286l99-42'
            + 'q22.77 23.38 48.69 38.31 25.93 14.92 57.31 22.92L440-160Zm40.46-200'
            + 'q49.92 0 84.96-35.04 35.04-35.04 35.04-84.96 0-49.92-35.04-84.96Q530.38-600 480.46-600'
            + 'q-50.54 0-85.27 35.04T360.46-480q0 49.92 34.73 84.96Q429.92-360 480.46-360ZM480-480Z',
    }),
    logout: Object.freeze({
        symbol: 'logout',
        path: 'M212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h238.08'
            + 'q12.76 0 21.38 8.62 8.61 8.61 8.61 21.38t-8.61 21.38q-8.62 8.62-21.38 8.62H212.31'
            + 'q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v535.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h238.08'
            + 'q12.76 0 21.38 8.62 8.61 8.61 8.61 21.38t-8.61 21.38q-8.62 8.62-21.38 8.62H212.31Zm492.38-310'
            + 'H393.85q-12.77 0-21.39-8.62-8.61-8.61-8.61-21.38t8.61-21.38q8.62-8.62 21.39-8.62h310.84'
            + 'l-76.92-76.92q-8.31-8.31-8.5-20.27-.19-11.96 8.5-21.27 8.69-9.31 21.08-9.62 12.38-.3 21.69 9'
            + 'l123.77 123.77q10.84 10.85 10.84 25.31 0 14.46-10.84 25.31L670.54-330.92'
            + 'q-8.92 8.92-21.19 8.8-12.27-.11-21.58-9.42-8.69-9.31-8.38-21.38.3-12.08 9-20.77l76.3-76.31Z',
    }),
    shieldPerson: Object.freeze({
        symbol: 'shield_person',
        path: 'M387.62-487.62Q350-525.23 350-580q0-54.77 37.62-92.38Q425.23-710 480-710q54.77 0 92.38 37.62'
            + 'Q610-634.77 610-580q0 54.77-37.62 92.38Q534.77-450 480-450q-54.77 0-92.38-37.62Zm142.3-42.46'
            + 'Q550-550.15 550-580t-20.08-49.92Q509.85-650 480-650t-49.92 20.08Q410-609.85 410-580t20.08 49.92'
            + 'Q450.15-510 480-510t49.92-20.08ZM480-479.62Zm0-315L240-705v189'
            + 'q0 57.08 16.35 110.39 16.34 53.3 45.42 99.46 40.46-20.62 84.73-32.23Q430.77-350 480-350'
            + 't93.5 11.62q44.27 11.61 84.73 32.23 29.08-46.16 45.42-99.46Q720-458.92 720-516v-189l-240-89.62Z'
            + 'm-74.42 513q-35.73 8.39-67.5 23.54 29.77 33.08 65.5 57.2Q439.31-176.77 480-164'
            + 'q40.69-12.77 76.23-36.88 35.54-24.12 65.31-57.2-31.77-15.15-67.31-23.54Q518.69-290 480-290'
            + 'q-38.69 0-74.42 8.38Zm62.19 175.46q-6-1-11.62-3-126.53-45-201.34-159.57Q180-383.31 180-516'
            + 'v-180.15q0-22.7 13.16-40.96 13.15-18.27 33.84-26.5l227.69-85'
            + 'q12.85-4.62 25.31-4.62 12.46 0 25.31 4.62l227.69 85q20.69 8.23 33.84 26.5Q780-718.85 780-696.15'
            + 'V-516q0 132.69-74.81 247.27-74.81 114.57-201.34 159.57-5.62 2-11.62 3-6 1-12.23 1t-12.23-1Z',
    }),
    badge: Object.freeze({
        symbol: 'badge',
        path: 'M246.15-251.54h227.7v-11.85q0-15.46-8.54-28.42T441.69-312'
            + 'q-19.61-8.62-39.73-12.92-20.11-4.31-41.96-4.31t-41.96 4.31'
            + 'q-20.12 4.3-39.73 12.92-15.08 7.23-23.62 20.19-8.54 12.96-8.54 28.42v11.85Zm337.7-60.77h112.3'
            + 'q10.31 0 17.08-6.77 6.77-6.77 6.77-17.07 0-10.31-6.77-17.08-6.77-6.77-17.08-6.77h-112.3'
            + 'q-10.31 0-17.08 6.77-6.77 6.77-6.77 17.08 0 10.3 6.77 17.07t17.08 6.77Zm-185.77-63.46'
            + 'q15.77-15.77 15.77-38.08 0-22.3-15.77-38.07T360-467.69q-22.31 0-38.08 15.77t-15.77 38.07'
            + 'q0 22.31 15.77 38.08T360-360q22.31 0 38.08-15.77ZM583.85-420h112.3'
            + 'q10.31 0 17.08-6.77 6.77-6.77 6.77-17.08 0-10.3-6.77-17.07t-17.08-6.77h-112.3'
            + 'q-10.31 0-17.08 6.77-6.77 6.77-6.77 17.07 0 10.31 6.77 17.08 6.77 6.77 17.08 6.77ZM172.31-100'
            + 'Q142-100 121-121q-21-21-21-51.31v-415.38Q100-618 121-639q21-21 51.31-21H380v-140'
            + 'q0-24.92 17.54-42.46T440-860h80q24.92 0 42.46 17.54T580-800v140h207.69Q818-660 839-639'
            + 'q21 21 21 51.31v415.38Q860-142 839-121q-21 21-51.31 21H172.31Zm0-60h615.38q5.39 0 8.85-3.46'
            + 't3.46-8.85v-415.38q0-5.39-3.46-8.85t-8.85-3.46H580v15.39'
            + 'q0 24.53-17.73 42.26-17.73 17.73-42.27 17.73h-80q-24.54 0-42.27-17.73Q380-560.08 380-584.61V-600'
            + 'H172.31q-5.39 0-8.85 3.46t-3.46 8.85v415.38q0 5.39 3.46 8.85t8.85 3.46ZM440-584.61h80V-800h-80'
            + 'v215.39ZM480-380Z',
    }),
    switchAccount: Object.freeze({
        symbol: 'switch_account',
        path: 'M637.88-542.84Q670-574.91 670-620.72'
            + 'q0-45.82-32.07-77.93-32.07-32.12-77.88-32.12-45.82 0-77.93 32.07Q450-666.63 450-620.81'
            + 'q0 45.81 32.07 77.93 32.07 32.11 77.88 32.11 45.82 0 77.93-32.07ZM331.54-326.15'
            + 'q43.85-49.54 103.38-76.31 59.54-26.77 125.08-26.77 65.54 0 125.08 26.77 59.53 26.77 103.38'
            + ' 76.31 5 0 8.27-3.66 3.27-3.65 3.27-8.65v-449.23q0-5.39-3.46-8.85t-8.85-3.46H332.31'
            + 'q-5.39 0-8.85 3.46t-3.46 8.85v449.23q0 5 3.27 8.65 3.27 3.66 8.27 3.66Zm.77 66.15'
            + 'q-29.83 0-51.07-21.24Q260-302.48 260-332.31v-455.38q0-29.83 21.24-51.07Q302.48-860 332.31-860'
            + 'h455.38q29.83 0 51.07 21.24Q860-817.52 860-787.69v455.38q0 29.83-21.24 51.07'
            + 'Q817.52-260 787.69-260H332.31Zm-160 160q-29.83 0-51.07-21.24Q100-142.48 100-172.31V-670'
            + 'q0-12.75 8.63-21.37 8.63-8.63 21.38-8.63 12.76 0 21.37 8.63Q160-682.75 160-670v497.69'
            + 'q0 5.39 3.46 8.85t8.85 3.46H670q12.75 0 21.37 8.63 8.63 8.63 8.63 21.38 0 12.76-8.63 21.37'
            + 'Q682.75-100 670-100H172.31Zm352.27-485.34Q510-599.92 510-620.77'
            + 'q0-20.84 14.58-35.42 14.57-14.58 35.42-14.58t35.42 14.58Q610-641.61 610-620.77'
            + 'q0 20.85-14.58 35.43-14.57 14.57-35.42 14.57t-35.42-14.57ZM413.38-320h293.24'
            + 'q-31.31-24.62-68.97-36.92Q600-369.23 560-369.23q-40 0-77.65 12.31-37.66 12.3-68.97 36.92Z'
            + 'M560-563.08Z',
    }),
});

export { ACCOUNT_ICON_VIEW_BOX };
export default ACCOUNT_ICONS;
